module.exports = __webpack_public_path__ + "static/media/gastritis.1e6685f1.jpg";